import {
    useMemo,
} from 'react'
import useDelayedLoadOptions from 'app/hooks/useDelayedLoadOptions'

import Requests from 'app/requests/Deployment.requests'

const useDeploymentLoadOptions = () => {
    const url = useMemo(() => {
        return Requests.filterRequest().url
    }, [])

    return useDelayedLoadOptions({
        url,
        params: {
            sortField: 'createdOn',
            sortType: 'desc',
            rows: 25,
            start: 0,
        },
    })
}

export default useDeploymentLoadOptions
